/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Created
 *
 * 1 = Authorised
 *
 * 2 = Pending
 *
 * 3 = Declined
 */
export enum CheckBoxJobStatus {
  Created = 0,
  Authorised = 1,
  Pending = 2,
  Declined = 3,
}
